import { I_VehicleSafetyEventsReference } from "../interfaces"

const vehicleSafetyEventsReferenceBoilerplate: I_VehicleSafetyEventsReference = {
    AllowedReviewers: [],
    ApprovalStatusTypesWithRules: []
}

export default vehicleSafetyEventsReferenceBoilerplate